module.exports = __webpack_public_path__ + "assets/img/qr.fddae20a.png";